export const FlightRoutes = {
  LIST: "/flights",
  DETAIL: "/flights/:id",
} as const;
